import { FC, useContext, useState } from 'react';
import styles from '../css/Login.module.scss';
import Header from './Header';
import AlertContext from './Alert';
import apiUrl from '../assets/apiUrl';
import {
  Avatar,
  Grid,
  Paper,
  TextField,
  Button,
  Typography,
  Link as LinkMUI,
} from '@material-ui/core';
import { HttpsOutlined } from '@material-ui/icons';

const ForgotPassword: FC = () => {
  const [email, setEmail] = useState('');
  const [isSent, setIsSent] = useState(false);
  const { show } = useContext(AlertContext);
  const onSubmit = async (e: any) => {
    e.preventDefault();
    try {
      const response = await fetch(`${apiUrl}/auth/change_password/${email}`);
      if (!response.ok) {
        throw response.statusText;
      }
      setIsSent(true);
    } catch (error: any) {
      show({ title: 'Change password error', body: error, type: 'error' });
    }
  };
  const paperStyle = {
    padding: 20,
    width: 280,
    margin: '20px auto',
  };
  return (
    <div className="homepage">
      <Header />
      <div className={styles.Login}>
        <Grid>
          <Paper elevation={10} style={paperStyle}>
            <Grid container spacing={0} direction="column" alignItems="center">
              <Avatar style={{ backgroundColor: '#f6690c' }}>
                <HttpsOutlined />
              </Avatar>
              <h2>Forgot Password</h2>
            </Grid>
            {!isSent && (
              <>
                <form onSubmit={onSubmit}>
                  <TextField
                    label="email"
                    placeholder="enter your email"
                    fullWidth
                    required
                    value={email}
                    onChange={(e) => setEmail(e.target.value)}
                  />
                  <Button
                    type="submit"
                    color="primary"
                    variant="contained"
                    fullWidth
                    onClick={onSubmit}
                    style={{ marginTop: '16px' }}
                  >
                    Send Recovery Email
                  </Button>
                </form>
                <Typography style={{ margin: '16px 0' }}>
                  <LinkMUI href="login">Login instead</LinkMUI>
                </Typography>
              </>
            )}
            {isSent && (
              <Typography style={{ margin: '16px 0' }}>
                <p>An email was sent to {email}</p>
                <LinkMUI href="/">Return to homepage</LinkMUI>
              </Typography>
            )}
          </Paper>
        </Grid>
      </div>
    </div>
  );
};

export default ForgotPassword;
